// Google Analytics 4 Measurement ID
// This is a public tracking ID, safe to include in client-side code
export const GA4_MEASUREMENT_ID = 'G-21LSS96R9M';
